export default __webpack_public_path__ + "static/media/47.a62f0891.jpeg";